import { ROLE_SUPERADMIN } from '../../constants/roles';
import { createHasUploadsAccessSelector } from '../session';

export const selectCanAccessUploads = createHasUploadsAccessSelector([ROLE_SUPERADMIN])